import { useState } from "react";
import { Divider } from "@/components/shared/divider";
import { Typography } from "@/components/shared/typography";
import { Button, Card } from "@/components/ui";
import { SwitchToRecurringDrawer } from "./section-switch-to-recurring";
import { SectionFindBestHelper } from "./section-find-best-helper";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import type { ServiceName } from "@/types/service";

export const UpgradePromoCard = ({ name }: { name: ServiceName }) => {
  const { isMobile } = useWindowDimensions();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [findHelperModalOpen, setFindHelperModalOpen] = useState(false);

  const onOpenFindHelper = () => {
    // Close the drawer first — React Native cannot show two Modals simultaneously.
    // Wait for the close animation to finish before opening the next modal.
    setDrawerOpen(false);
    setTimeout(() => setFindHelperModalOpen(true), 300); // 300 for standard animation
  };
  return (
    <>
      <Card className="p-3">
        <Typography variant="body-sm" className="mb-2">
          Your Slot, Guaranteed ✨
        </Typography>
        <Typography
          variant="body-sm"
          color="foreground-intermediate"
          className="inline leading-[20px]"
        >
          Lock in a regular cleaner, weekly or fortnightly, from just{" "}
          <Typography
            variant="label-sm"
            color="brand-primary"
            className="inline"
          >
            $18/hr.
          </Typography>
        </Typography>
        <Divider className="my-3" />
        <Button
          variant="secondary"
          color="CTA2"
          size={isMobile ? "xs" : "sm"}
          onClick={() => {
            setDrawerOpen(true);
          }}
        >
          See Options
        </Button>
      </Card>

      <SwitchToRecurringDrawer
        open={drawerOpen}
        onOpenChange={setDrawerOpen}
        onOpenFindHelper={onOpenFindHelper}
      />
      <SectionFindBestHelper
        open={findHelperModalOpen}
        onOpenChange={setFindHelperModalOpen}
        name={name}
      />
    </>
  );
};
